import { Box, BoxProps, Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import FancyBearImage from "components/FancyBearImage";
import SelectionIndicator from "components/SelectionIndicator";
import { ImageSize } from "types";

export type FancyBearCardProps = BoxProps & {
  tokenId: number;
  imageSize?: ImageSize;
  isSelected?: boolean;
  isBusy?: boolean;
  isDisabled?: boolean;
  onClick?: (tokenId: number) => void;
};

const FancyBearCard: React.FC<FancyBearCardProps> = ({
  tokenId,
  imageSize,
  isDisabled = false,
  isSelected = false,
  isBusy = false,
  bg = "bright.500",
  children,
  onClick,
  ...rest
}) => (
  <Box
    bg={bg}
    p="2"
    w="full"
    outline="2px solid"
    userSelect="none"
    outlineColor={isSelected ? "dark.500" : "transparent"}
    cursor={isDisabled ? "not-allowed" : onClick ? "pointer" : "default"}
    transition="all 0.15s"
    tabIndex={0}
    onClick={() => {
      if (!isDisabled && onClick) {
        onClick(tokenId);
      }
    }}
    {...rest}
  >
    <Box position="relative">
      <FancyBearImage
        size={imageSize}
        tokenId={tokenId}
        isDisabled={isDisabled || isBusy}
      />

      <SelectionIndicator
        position="absolute"
        bg={bg}
        color="primary.500"
        top="-2"
        left="-2"
        isSelected={isSelected}
      />

      <Center
        position="absolute"
        top="-2"
        right="-2"
        bg="bright.500"
        w="10"
        h="10"
        zIndex="dropdown"
        opacity={isBusy ? "1" : "0"}
        transition="opacity 0.15s"
      >
        {isBusy && <BoldSpinner size="sm" thickness="3px" />}
      </Center>
    </Box>

    <Box px="2" pt="3" pb="1">
      {children}
    </Box>
  </Box>
);

export default FancyBearCard;
